
export default {
  i18nComponentKey: 'ReviewsEditLegacy.components.ProductInfo',
  name: 'ProductInfo',
  props: {
    imageUrl: { type: String, required: true },
    name: { type: String, required: true }
  }
};
